import _ from 'lodash';
import moment from 'moment';

import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Link } from 'react-router-dom';

import ReactTooltip from 'react-tooltip';

import salesCompetencyInventoryPie from '../../assets/images/sales-competency-inventory/Sales-Competency-Inventory-Pie.svg';

import {
 Page,
 StarRating,
 ScoreDial,
 ScoreProgress,
} from '../shared';

import {
 MessageModal
} from '../modals';

import {
 getSellingCompetency,
 sellingCompetencies,
 getCompetencyScoreFromQuestionsAndResponses,
 getCoachabilityScoreFromQuestionsAndResponses,
 getTierFromScore,
 getScoreDescriptions,
 getPredictiveSkillsReviewScoresFromReviewData,
 navPrefix,
 getTierDetails,
 getIcon,
 scrollTo,
 getDefaultTalentRatingExplanations,
 personalizeString,
} from '../../util';

import {
 getFormattedQuarterFromDate,
} from '../../util/quarters';

import {
 fetchSalesCompetencyReview,
 fetchSalesCompetencyReviewItems,
} from '../../actions/salesCompetencyReviews';

import {
  fetchLatestScoredTalentAssessmentForUser
} from '../../actions/assessments';

import {
 ScoredCriticalExpertiseItemsSelector
} from '../../selectors';

const LIKERT_RATING_EXPLANATIONS = [
 'Very Strongly Disagree',
 'Strongly Disagree',
 'Disagree',
 'Neutral',
 'Agree',
 'Strongly Agree',
 'Very Strongly Agree',
];

const RATING_TIERS = [
 {
  value: 1,
  label: 'Beginner',
  description: 'Bottom 25% of sellers fall into this tier, and should seek assistance in COMPETENCY_PLACEHOLDER whenever possible. These individuals have a lot to learn and should prioritize improvement in COMPETENCY_PLACEHOLDER at every opportunity. While NAME_PLACEHOLDER might be making progress, they still have many areas that are underdeveloped and are severly inhibiting their ability to meet objectives and win business.',
  proportion: 25,
 },
 {
  value: 2,
  label: 'Novice',
  description: 'Bottom 50% are in or below this tier. These individuals lack proficiency in COMPETENCY_PLACEHOLDER and often face challenges that require the assistance of others and/or result in missed opportunities. While NAME_PLACEHOLDER might be making decent progress in this cateogry, they have many areas for improvement in order to utilize COMPETENCY_PLACEHOLDER to win business consistently.',
  proportion: 25,
 },
 {
  value: 3,
  label: 'Intermediate',
  description: 'Top 50% of all sellers are in or above this tier. These individuals possess some proficiency in COMPETENCY_PLACEHOLDER, but often face challenges that require the assistance of others or result in missed opportunities. While NAME_PLACEHOLDER has noticeable strengths in this area, they also have several areas for improvement that need to be worked on before they can reliably utilize COMPETENCY_PLACEHOLDER to win business consistently.',
  proportion: 25,
 },
 {
  value: 4,
  label: 'Advanced',
  description: 'Top 25% of all sellers are in or above this tier. These individuals possess many proficiencies in COMPETENCY_PLACEHOLDER, but occasionally face challenges that require the assistance of others or result in missed opportunities. While NAME_PLACEHOLDER has many strengths in this area, they also have noticeable areas for improvement that need to be worked on before they can reliably utilize COMPETENCY_PLACEHOLDER to win business consistently.',
  proportion: 15,
 },
 {
  value: 5,
  label: 'Expert',
  description: 'Top 10% of all sellers are in or above this tier. These individuals possess extreme proficiency in COMPETENCY_PLACEHOLDER, and often these strengths directly contribute to improved win rates and velocity, as well as the seller’s ability to consistently hit their numbers. While there is still room for improvement, NAME_PLACEHOLDER is able to consistently utilize their strengths in this category to win business and very rarely struggles in COMPETENCY_PLACEHOLDER.',
  proportion: 5,
 },
 {
  value: 6,
  label: 'Professional',
  description: 'Top 5% of all sellers are in or above this tier. These individuals possess extreme proficiency in COMPETENCY_PLACEHOLDER, and often these strengths directly contribute to improved win rates and deal velocity, as well as the seller’s ability to consistently hit their numbers. NAME_PLACEHOLDER’s tactics for COMPETENCY_PLACEHOLDER should be emulated across our organization.',
  proportion: 4,
 },
 {
  value: 7,
  label: 'Best in Class',
  description: 'Very few exceptional sellers are best in class in any selling competency, let alone multiple. These are generally the most talented individuals you have come across in your career. This seller\'s tactics in this selling competency should be emulated across our organization. On more than one occasion NAME_PLACEHOLDER has taught you something new about COMPETENCY_PLACEHOLDER.',
  proportion: 1,
 },
];

class ViewTalentReview extends Component {

 state = {
  viewingPage: 'intro',
  //viewingPage: 'coachability',
  sortingCompetenciesBy: 'Most Improved',
  sortingExpertiseBy: 'Most Improved',
  viewingItems: {},
  printViewToggled: false,
  hasSeenPrintViewInstructions: false,
  showingPrintViewInstructions: false,
 }

 togglePrintView(){

  const toggleOn = !this.state.printViewToggled;

  this.setState({
   printViewToggled: toggleOn,
   showingPrintViewInstructions: !this.state.hasSeenPrintViewInstructions && toggleOn,
  });
 }

 componentDidUpdate(prevProps, prevState){
  //if loaded review w/o prior, don't show most improved, and also fetch talent assessment data for comparisons if available
  if(!prevProps.currentReview && this.props.currentReview && !this.props.priorReview){
   this.setState({
    sortingCompetenciesBy: 'Strongest',
    sortingExpertiseBy: 'Strongest',
   });

   if(this.props.organization.compareInitialSalesCompetencyReviewWithTalentAssessmentResponses){
     // console.log('fetching latest scored talent assessment for user: ', this.props.currentReview.seller);
     fetchLatestScoredTalentAssessmentForUser(this.props.currentReview.seller, compareWithLatestTalentAssessment => {
       // console.log('compareWithLatestTalentAssessment: ', compareWithLatestTalentAssessment);
       this.setState({
         compareWithLatestTalentAssessment,
       });
     });
   }
  }

  //if expanding/minimizing sections, refresh tooltips
  if(!_.isEqual(prevState.viewingItems, this.state.viewingItems) || prevState.viewingPage !== this.state.viewingPage){
    // console.log('rebuilding tooltips!');
    ReactTooltip.rebuild();
  }
 }

 hasPriorReview(){
  return this.props.priorReview;
 }
 hasPriorTalentAssessment(){
   return !!this.state.compareWithLatestTalentAssessment;
 }

 scoresFromReviewData(){
  return getPredictiveSkillsReviewScoresFromReviewData(this.props.salesCompetencyReviewItems, this.props.scoredCriticalExpertiseItems, this.props.currentReview, this.props.priorReview);
 }

 sortedCompetencyScores(){
  const scores = this.scoresFromReviewData();
  const { scoresByCompetency } = scores;
  console.log('sorting competency scores: ', scoresByCompetency);

  const {
   sortingCompetenciesBy,
   printViewToggled,
  } = this.state;

  if(printViewToggled || sortingCompetenciesBy === 'Strongest'){
   return _.orderBy(scoresByCompetency, 'score', 'desc');
  }
  else if(sortingCompetenciesBy === 'Weakest'){
   return _.orderBy(scoresByCompetency, 'score', 'asc');
  }
  else if(sortingCompetenciesBy === 'Most Improved'){
   return _.orderBy(scoresByCompetency, scores => {
    return scores.delta || 0;
   }, 'desc');
  }
  else{
   //default order aka "Deal Order"
   return scoresByCompetency;
  }
 }
 sortedExpertiseScores(){
  const scores = this.scoresFromReviewData();
  const { scoresByCriticalExpertise } = scores;

  const {
   sortingExpertiseBy,
   printViewToggled,
  } = this.state;

  if(printViewToggled || sortingExpertiseBy === 'Strongest'){
   return _.orderBy(scoresByCriticalExpertise, 'score', 'desc');
  }
  else if(sortingExpertiseBy === 'Weakest'){
   return _.orderBy(scoresByCriticalExpertise, 'score', 'asc');
  }
  else if(sortingExpertiseBy === 'Most Improved'){
   return _.sortBy(scoresByCriticalExpertise, scores => {
    return -1 * (scores.delta || 0);
   });
  }
  else{
   return _.orderBy(scoresByCriticalExpertise, 'score', 'desc');
  }
 }

 renderTakeawaysPage(){
  const scores = this.scoresFromReviewData();

  const {
   competencyScore,
   competencyTier,
   competencyDelta,
   expertiseScore,
   expertiseTier,
   expertiseDelta,
   coachabilityScore,
   coachabilityTier,
   coachabilityDelta,
   overallScore,
   overallTier,
   overallDelta,
   scoresByCompetency,
   scoresByCriticalExpertise,
   topCompetencies,
   bottomCompetencies,
   topExpertise,
   bottomExpertise,
   overEstimated,
   underEstimated,
  } = scores;

  const {
    isOwnReview
  } = this.props;

  const {
   printViewToggled
  } = this.state;

  return (
   <div className="review-page">
    <div className="review-page-hero force-break">
     <h2>Key Takeaways</h2>
     {isOwnReview &&
       <React.Fragment>
         <p>Competency development to drive performance improvement is all about focus. The below areas are designed to focus your time to accelerate growth every week, month, and quarter. How you receive and apply feedback from this report will determine if it helps you get better. To prepare your mindset for improvement, start with a review of your Coachability score.</p>
         <h3>Coachability Score <div className={`inline-score tier-${coachabilityTier}-bg`}>{coachabilityScore}</div></h3>
         <p>Sellers who continually improve with experience bring a Coachable mindset that enables optimal growth. An appetite for feedback, an open perspective, and an ability to adapt your habits to improve your effectiveness comprises your Coachability score.</p>
         <p>As you begin work on your Coachability, keep in mind that the best sellers seek out guidance, not only from managers, but also from company and industry leaders, selling peers, and customers.</p>
       </React.Fragment>
     }
     {!isOwnReview &&
       <React.Fragment>
         <p>Competency development to drive performance improvement is all about focus. The below areas are designed to focus seller time to accelerate growth every week, month, and quarter. How sellers receive and apply feedback from this report will determine if it helps them get better. To prepare each seller with a mindset for improvement, start with a review of their Coachability score.</p>
         <h3>Coachability Score <div className={`inline-score tier-${coachabilityTier}-bg`}>{coachabilityScore}</div></h3>
         <p>Sellers who continually improve with experience bring a Coachable mindset that enables optimal growth. An appetite for feedback, an open perspective, and an ability to adapt habits to improve effectiveness comprises the Seller’s Coachability score.</p>
         <p>{this.personalizeWithSellerInfo(`As __HESHE__ begins work on __HISHER__ Coachability, keep in mind that the best sellers seek out guidance, not only from managers, but also from company and industry leaders, selling peers, and customers.`)}</p>
       </React.Fragment>
     }
    </div>
    <div className="review-page-section force-break">
     <h3>Greatest Areas for Improvement</h3>
     {isOwnReview &&
       <p>Below are your weakest selling competencies and critical expertise items. Focus your attention on strategies to mitigate the impact of these weak areas on performance. Also, develop targeted skills to shrink these gaps so they don’t inhibit your success over the upcoming months.</p>
     }
     {!isOwnReview &&
       <p>{this.personalizeWithSellerInfo(`Below are __SELLERNAMEP__ weakest selling competencies and critical expertise items. Focus __SELLERNAMEP__ attention on strategies to mitigate the impact of these weak areas on performance and develop targeted skills to shrink these gaps so they don’t inhibit __HISHER__ success over the upcoming months.`)}</p>
     }
     <div className="components-list extra-padding">
      <h6>SELLING COMPETENCIES</h6>
      <ul className="thirds">
       {_.map(_.take(bottomCompetencies, 3), item => {
        return (
         <li onClick={() => { this.viewPage('competencies', item.id) }} key={`competency-item-${item.id}`}><small className={`component-score tier-${item.tier}-bg`}>{item.score}</small>{item.name}</li>
        )
       })}
      </ul>
     </div>
     <div className="components-list">
      <h6>CRITIAL EXPERTISE</h6>
      <ul className="thirds">
       {_.map(_.take(bottomExpertise, 3), item => {
        return (
         <li onClick={() => { this.viewPage('expertise', item.id) }} key={`expertise-item-${item.id}`}><small className={`component-score tier-${item.tier}-bg`}>{item.score}</small>{item.name}</li>
        )
       })}
      </ul>
     </div>
     <h3>Blind Spots</h3>
     {isOwnReview &&
       <p>Below are areas where you rate yourself stronger than your manager rates you. Pay attention to these items, as they are either areas in which you are overconfident in your abilities, or areas that you have not been able to demonstrate effectiveness to your manager.</p>
     }
     {!isOwnReview &&
       <p>{this.personalizeWithSellerInfo(`Below are areas where __SELLERNAME__ rated __HIMSELFHERSELF__ stronger than you rated __HIMHER__. Pay attention to these items, as they are either areas in which __SELLERNAME__ is overconfident in __HISHER__ abilities, or areas that __SELLERNAME__ has potential, but you have not been able to observe __HISHER__ in action at __HISHER__ best.`)}</p>
     }
     <div className="components-list">
      <ul className="thirds">
       {_.map(_.take(overEstimated, 3), item => {
        return (
         <li onClick={() => { this.viewPage('competencies', item.id) }} key={`overestimated-item-${item.id}`}><small className={`component-diff`}>{item.diff}</small>{item.name}</li>
        )
       })}
      </ul>
     </div>
     <h3>Hidden Strengths</h3>
     {isOwnReview &&
       <p>Below are areas where your manager rates you stronger than you rate yourself. These are areas to examine how you have demonstrated competency through your natural strengths. These could be relative strengths that you have not fully recognized or appreciated. When applied more frequently, these may be opportunities for improved results.</p>
     }
     {!isOwnReview &&
       <p>{this.personalizeWithSellerInfo(`Below are areas where you rate __SELLERNAME__ stronger than __HESHE__ rates __HIMSELFHERSELF__. These are areas for __HISHER__ to examine how __HESHE__ has demonstrated competency through __HISHER__ natural strengths. These could be relative strengths that __HESHE__ has not fully recognized or appreciated. When applied more frequently, these may be opportunities for improved results.`)}</p>
     }
     <div className="components-list">
      <ul className="thirds">
       {_.map(_.take(underEstimated, 3), item => {
        return (
         <li onClick={() => { this.viewPage('competencies', item.id) }} key={`underestimated-item-${item.id}`}><small className={`component-diff`}>+{item.diff}</small>{item.name}</li>
        )
       })}
      </ul>
     </div>
    </div>
   </div>
  );
 }

 renderIntroPage(){
  if(this.props.isOwnReview){
   return (
    <div className="review-page">
     <div className="review-page-hero">
      <h2 className="no-print">About This Review</h2>
      <div className="strong explanation large">Your Sales Competency Review is designed to accelerate your individual performance improvement through applying and developing your personal strengths and predictive selling skills that most contribute to success within your role. Your results will illuminate a clear path with recommendations to leverage your natural selling strengths and to close your skill gaps to achieve elite sales performance.</div>
      <img className="pie" src={salesCompetencyInventoryPie} />
      <h3 style={{marginTop: 25}}>What is Measures</h3>
      <p>Through more than 25 years of empirical research, AuctusIQ has refined a weighted scoring algorithm of what most contributes to the success of a seller. The AuctusIQ Sales Competency Inventory (SCI) measures your Ten Performance-based Selling Competencies, your Critical Expertise, and your Coachability for continuous improvement selling. Your SCI results deliver insight to apply yourself and multiply your impact while shrinking the time required to successfully manage and close complex sales opportunities.</p>
      <h3 style={{marginTop: 25}}>Why it works</h3>
      <p>The Ten Predictive Sales Competencies measured through the SCI assessment are the product of hundreds of studies with millions of sellers to reveal what is different about the Top 20% Elite performers year over year that enables them to consistently produce more with shorter sales cycles. For each critical moment during the selling cycle, top performing sellers ask the right questions, make smart decisions, and take key action steps that expedite progress to close. The secrets to success are embedded in the results of this assessment so you know exactly what you need to do to get better.</p>
      <h3 style={{marginTop: 25}}>Next steps</h3>
      <p>After reviewing your report, you will work with your manager to create an action plan, identifying the Selling Competencies and Critical Expertise you will prioritize improving throughout the quarter to deliver on your sales targets.</p>
     </div>
    </div>
   );
  }
  else{
   return (
    <div className="review-page">
     <div className="review-page-hero">
      <h2 className="no-print">About This Review</h2>
      <div className="strong explanation large">{this.personalizeWithSellerInfo('__SELLERNAMEP__ Sales Competency Review is designed to accelerate __HISHER__ individual performance improvement through applying and developing __HISHER__ personal strengths and predictive selling skills that most contribute to success within __HISHER__ role. These results illuminate a clear path with recommendations to leverage natural selling strengths with strategies to close __HISHER__ skill gaps to build competency and achieve elite sales performance.')}</div>
      <img className="pie" src={salesCompetencyInventoryPie} />
      <h3 style={{marginTop: 25}}>What is Measures</h3>
      <p>Through more than 25 years of empirical research, AuctusIQ has refined a weighted scoring algorithm of what most contributes to the success of a seller. The AuctusIQ Sales Competency Inventory (SCI) measures each seller’s Ten Performance-based Selling Competencies, Critical Expertise, and Coachability for continuous improvement as a sales professional. The SCI results deliver insight to apply and multiply seller impact while shrinking the time required to successfully manage and close complex sales opportunities.</p>
      <h3 style={{marginTop: 25}}>Why it works</h3>
      <p>The Ten Predictive Sales Competencies measured through the SCI assessment are the product of hundreds of studies with millions of sellers to reveal what is different about the Top 20% Elite performers year over year that enables them to consistently produce more with shorter sales cycles. For each critical moment during the selling cycle, top performing sellers ask the right questions, make smart decisions, and take key action steps that expedite progress to close. The secrets to success are embedded in the results of this assessment so sellers know exactly what they need to do to get better.</p>
      <h3 style={{marginTop: 25}}>Next steps</h3>
      <p>{this.personalizeWithSellerInfo('After reviewing __SELLERNAMEP__ report, you will work with __SELLERNAME__ to create an action plan, identifying the Selling Competencies and Critical Expertise __SELLERNAME__ will prioritize improving throughout the quarter to deliver on __HISHER__ sales targets.')}</p>
     </div>
    </div>
   );
  }
 }

 getScoreClassification(score){
   if(getTierFromScore(score) < 3){
     return 'low';
   }
   else if(getTierFromScore(score) < 6){
     return 'average';
   }
   else{
     //tier == 6 or 7
     return 'high';
   }
 }

 renderSummaryPage(){

  const scores = this.scoresFromReviewData();

  const {
   competencyScore,
   competencyTier,
   competencyDelta,
   expertiseScore,
   expertiseTier,
   expertiseDelta,
   coachabilityScore,
   coachabilityTier,
   coachabilityDelta,
   overallScore,
   overallTier,
   overallDelta,
   scoresByCriticalExpertise,
  } = scores;

  const {
   isOwnReview,
   currentReview,
  } = this.props;

  const criticalExpertiseCount = _.size(scoresByCriticalExpertise);

  const overallScoreMessage = (overallDelta && overallDelta > 0) ? ` That\'s an improvement of ${overallDelta} since your last review. Nicely done!` : (overallScore > 75 ? ` Nicely done!` : '');

  return (
   <div className="review-page">
    <div className="review-page-hero">
     <h2>Score Summary</h2>
     <ScoreProgress
      size="large"
      score={overallScore}
      priorScore={Number.isFinite(overallDelta) && overallScore - overallDelta}
      delta={overallDelta}
      className={`tier-${overallTier}`}
      color={getTierDetails(overallTier).color}
      />
     {isOwnReview &&
      <React.Fragment>
       <div className="strong explanation">
        {this.getScoreClassification(overallScore) === 'high' &&
         <div className="strong explanation">Excellent job! Your overall score of <b>{overallScore}</b> is at or above the Top Performing Global Benchmark comparison of elite sellers in similar sales roles. For an overview on how to continue to improve your impact, check out the Key Takeways in the next section of this report.</div>
        }
        {this.getScoreClassification(overallScore) === 'average' &&
         <div className="strong explanation">Nicely done! Your overall score of <b>{overallScore}</b> is closely aligned to the Top Performing Global Benchmark comparison of elite sellers in similar sales roles. For an overview on how to continue to improve your impact, check out the Key Takeaways in the next section of this report.</div>
        }
        {this.getScoreClassification(overallScore) === 'low' &&
         <div className="strong explanation">Making progress! While your overall score of <b>{overallScore}</b> falls below the Top Performing Global Benchmark comparison of elite sellers in similar sales roles. You bring valuable strengths and opportunities for skill development to continue to grow your competency and increase your impact through the results of your SCI assessment. For an overview on how to improve your impact, check out the Key Takeaways in the next section of this report.</div>
        }
       </div>
       <div className="strong explanation">Your SCI responses are weighted based upon their relative impact on performance to provide you an overall Predictive Total Score to track your Sales Competency Improvement over time. To get better, you will learn how to leverage your leading strengths at critical stages of the sales cycle and how to mitigate your greatest gaps at critical stages of the sales cycle. Your findings will reveal any “Blind Spots” where you are not showing up as well as you expected and possible “Hidden Strengths” where your manager sees unrealized potential in you with capacity for development.</div>
       <div className="explanation"><small>The SCI Weighted Total is made of a 60% weight for your response scores for the 10 Predictive Selling Competencies, a 25% weight for your response scores for your Critical Expertise, and a 15% weight for your overall Coachability as a Seller. Based upon your SCI Assessment completed by both you and your manager in {moment(currentReview.startedOn).format('MMMM')} {moment(currentReview.startedOn).year()}, your Overall Weighted Total is {overallScore}.</small></div>
      </React.Fragment>
     }
     {!isOwnReview &&
      <React.Fragment>
       <div className="strong explanation">
        {this.getScoreClassification(overallScore) === 'high' &&
         <div className="strong explanation">{this.personalizeWithSellerInfo('This is an Excellent Overall Score! __SELLERNAMEP__ overall score is at or above the Top Performing Global Benchmark comparison of elite sellers in similar sales roles. For an overview on how to continue to improve __SELLERNAMEP__ impact, check out the Key Takeways in the next section of this report.')}</div>
        }
        {this.getScoreClassification(overallScore) === 'average' &&
         <div className="strong explanation">{this.personalizeWithSellerInfo('This is a Strong Overall Score! __SELLERNAMEP__ overall score is closely aligned to the Top Performing Global Benchmark comparison of elite sellers in similar sales roles. For an overview on how to continue to improve __SELLERNAMEP__ impact, check out the Key Takeaways in the next section of this report.')}</div>
        }
        {this.getScoreClassification(overallScore) === 'low' &&
         <div className="strong explanation">{this.personalizeWithSellerInfo('This is an Average Overall Scores. While __SELLERNAMEP__ overall score falls well below the Top Performing Global Benchmark comparison of elite sellers in similar sales roles, __HESHE__ brings valuable strengths and opportunities for skill development to continue to grow __HISHER__ competency and increase __HISHER__ impact through the results of __HISHER__ SCI assessment. For an overview on how to improve __HISHER__ impact, check out the Key Takeaways in the next section of this report.')}</div>
        }
       </div>
       <div className="strong explanation">Each Seller’s SCI responses are weighted based upon their relative impact on performance to provide an overall Predictive Total Score to track Sales Competency Improvement over time. To get better, your sellers need to learn how to leverage their leading strengths at critical stages of the sales cycle and how to mitigate their greatest gaps at critical stages of the sales cycle. Each report will reveal possible “Blind Spots” where the seller rates themselves significantly above your rating of them, and possible “Hidden Strengths” where you rate them significantly higher than they rate themselves, revealing possible unrealized potential strengths with capacity for development.</div>
       <div className="explanation"><small>{this.personalizeWithSellerInfo(`The SCI Weighted Total is made of a 60% weight of seller response scores for the 10 Predictive Selling Competencies, a 25% weight of seller response scores for their Critical Expertise, and a 15% weight of seller overall Coachability for ongoing improvement. Based upon __SELLERNAMEP__ SCI Assessment completed by both you and __SELLERNAME__ in ${moment(currentReview.startedOn).format('MMMM')} ${moment(currentReview.startedOn).year()}, __SELLERNAMEP__ Overall Weighted Total is ${overallScore}.`)}</small></div>
      </React.Fragment>
     }
    </div>

    <div className="review-page-section">

     <div className="group-score">
      <div className="value">
       <ScoreDial
        size="large"
        score={competencyScore}
        delta={competencyDelta}
        className={`tier-${competencyTier}`}
        />
      </div>
      <div className="label">
       <div className="name">Selling Competencies</div>
       <div className="percent-of-overall">60% of Overall Score</div>
       {!this.state.printViewToggled &&
        <div onClick={() => { this.viewPage('competencies') }} className="report-link no-print">View Selling Competencies Results</div>
       }
      </div>
     </div>

     <div className="group-score">
      <div className="value">
       <ScoreDial
        size="large"
        score={expertiseScore}
        delta={expertiseDelta}
        className={`tier-${expertiseTier}`}
        />
      </div>
      <div className="label">
       <div className="name">Critical Expertise</div>
       <div className="percent-of-overall">25% of Overall Score</div>
       {!this.state.printViewToggled &&
        <div onClick={() => { this.viewPage('expertise') }} className="report-link no-print">View Critical Expertise Results</div>
       }
      </div>
     </div>

     <div className="group-score">
      <div className="value">
       <ScoreDial
        size="large"
        score={coachabilityScore}
        delta={coachabilityDelta}
        className={`tier-${coachabilityTier}`}
        />
      </div>
      <div className="label">
       <div className="name">Coachability</div>
       <div className="percent-of-overall">15% of Overall Score</div>
       {!this.state.printViewToggled &&
        <div onClick={() => { this.viewPage('coachability') }} className="report-link no-print">View Coachability Results</div>
       }
      </div>
     </div>

    </div>
    <div className="review-page-section">
      {isOwnReview && !this.state.compareWithLatestTalentAssessment &&
        <div className="score-type-explanation">Each of these component scores takes into account both your responses, indicated on the following pages with {getIcon('review-self')}, and your manager's responses, indicated with {getIcon('review-reviewer')}.</div>
      }
      {isOwnReview && this.state.compareWithLatestTalentAssessment &&
        <div className="score-type-explanation">Each of these component scores takes into account both your responses, indicated on the following pages with {getIcon('review-self')}, and your manager's responses, indicated with {getIcon('review-reviewer')}. Your responses from your most recent Talent Assessment are also shown for select questions and indicated with {getIcon('talents')}.</div>
      }
      {!isOwnReview && !this.state.compareWithLatestTalentAssessment &&
        <div className="score-type-explanation">Each of these component scores takes into account both your responses, indicated on the following pages with {getIcon('review-reviewer')}, and your seller's responses, indicated with {getIcon('review-self')}.</div>
      }
      {!isOwnReview && this.state.compareWithLatestTalentAssessment &&
        <div className="score-type-explanation">Each of these component scores takes into account both your responses, indicated on the following pages with {getIcon('review-reviewer')}, and your seller's responses, indicated with {getIcon('review-self')}. This seller's latest talent assessment responses for select questions are also shown and indicated with {getIcon('talents')}.</div>
      }
    </div>
   </div>
  );
 }

 toggleViewingItem(itemId){
  this.setState({
   viewingItems: {
    ...this.state.viewingItems,
    [itemId]: !this.state.viewingItems[itemId]
   }
  });
 }

 questionsForItem(item){
  const questionsForItem = _.filter(this.props.salesCompetencyReviewItems || [], question => {
   return question.competencyIndex === item.id;
  });

  return _.orderBy(questionsForItem, 'questionIndex');
 }
 coachabilityQuestions(){
  const questions = _.filter(this.props.salesCompetencyReviewItems || [], question => {
   return question.questionType === 'coachability';
  });

  return _.orderBy(questions, 'questionIndex');
 }

 getResponseForQuestion(questionId, forUser = 'average', forPriorReview = false){
  const sellerResponse = (((forPriorReview ? this.props.priorReview : this.props.currentReview) || {}).sellerResponses || {})[questionId];
  const reviewerResponse = (((forPriorReview ? this.props.priorReview : this.props.currentReview) || {}).reviewerResponses || {})[questionId];

  return forUser === 'average' ? ((sellerResponse + reviewerResponse) / 2) : (forUser === 'reviewer' ? reviewerResponse : sellerResponse);
 }

 getCompetencyItemsToLeverage(questions){

  let itemsToLevearge = [];

  _.each(questions, question => {
   const score = this.getResponseForQuestion(question.id);

   if(score > 5){
    itemsToLevearge.push({
     item: question,
     score
    });
   }
  });

  //only take top 2
  // console.log('sorted TOP = ', _.orderBy(itemsToLevearge, 'score', 'desc'));
  itemsToLevearge = _.take(_.orderBy(itemsToLevearge, 'score', 'desc'), 2);

  return _.size(itemsToLevearge) > 0 && _.map(itemsToLevearge, 'item');
 }
 getCompetencyItemsToImprove(questions){

  let itemsToImprove = [];

  _.each(questions, question => {
   const score = this.getResponseForQuestion(question.id);

   if(score < 4){
    itemsToImprove.push({
     item: question,
     score
    });
   }
  });

  //only take bottom 2
  // console.log('sorted BOTTOM = ', _.orderBy(itemsToImprove, 'score', 'asc'));
  itemsToImprove = _.take(_.orderBy(itemsToImprove, 'score', 'asc'), 2);

  return _.size(itemsToImprove) > 0 && _.map(itemsToImprove, 'item');
 }

  competencyDescriptionForProficiency(competency, proficiency){
    const personalizedDescription = personalizeString(competency.descriptionsByProficiency[proficiency][this.props.isOwnReview ? 'own' : 'manager'], this.sellerName(), ((this.props.viewingUser || {}).profileMeta || {}).gender);

    return personalizedDescription;
 }

 personalizeWithSellerInfo(stringToPersonalize){
   return personalizeString(stringToPersonalize, this.sellerName(), ((this.props.viewingUser || {}).profileMeta || {}).gender);
 }

 renderCompetenciesPage(){

  const scores = this.scoresFromReviewData();

  const {
   competencyScore,
   competencyTier,
   competencyDelta,
   scoresByCompetency,
   topCompetencies,
   bottomCompetencies,
   overEstimatedCompetencies,
   underEstimatedCompetencies,
  } = scores;

  const {
    isOwnReview
  } = this.props;

  const { printViewToggled } = this.state;

  const competencies = sellingCompetencies();

  return (
   <div className="review-page">
    <div className="review-page-hero">
     <h2>Selling Competencies</h2>
      <ScoreProgress
       size="large"
       score={competencyScore}
       priorScore={Number.isFinite(competencyDelta) && competencyScore - competencyDelta}
       delta={competencyDelta}
       className={`tier-${competencyTier}`}
       color={getTierDetails(competencyTier).color}
       />
     {isOwnReview &&
       <React.Fragment>
         <p>The Ten Predictive Selling Competencies capture what the best sellers deliver at every stage of the sales cycle to shrink time and close more sales opportunities. The talents, skills, and experiences of each Seller define their most effective practices, impact actions, and judgment in making decisions</p>
         <p>Each Predictive Selling Competency contributes equally to your overall Selling Competency score and to your overall performance. Your goal is to review your leading strengths and greatest gaps to uncover the skills you need to advance through every stage of the sales cycle.</p>
         <p>First, identify your High-Scoring Competencies and find more situations where you can apply these competencies to help your team win. Then, identify your Low-Scoring Competencies and drill down on the details below to find a path for improvement so you can overcome your obstacles in the sales cycle.</p>
      </React.Fragment>
     }
     {!isOwnReview &&
       <React.Fragment>
         <p>{this.personalizeWithSellerInfo('The Ten Predictive Selling Competencies capture what the best sellers deliver at every stage of the sales cycle to shrink time and close more sales opportunities. The talents, skills, and experiences of each Seller define their most effective practices, impact actions, and judgment in making decisions.')}</p>
         <p>{this.personalizeWithSellerInfo('Each Predictive Selling Competency contributes equally to your overall Selling Competency score and to your overall performance. Your goal is to help your sellers understand their leading strengths and greatest gaps to uncover the skills they need to advance through every stage of the sales cycle.')}</p>
         <p>{this.personalizeWithSellerInfo('First, identify each seller’s High-Scoring Competencies and find more situations where they can apply these competencies to help your team win. Then, identify each seller’s Low-Scoring Competencies and drill down on the details below to find a path for improvement so you can help them overcome their obstacles in the sales cycle.')}</p>
      </React.Fragment>
     }
     {/*<h3>Competencies Score: Above Average <div className={`inline-score tier-${competencyTier}-bg`}>{competencyScore}</div></h3>*/}

     <div className="components-list">
      <p>&nbsp;</p>
      <h6>TOP STRENGTHS</h6>
      <ul className="thirds">
       {_.map(_.take(topCompetencies, 3), item => {
        return (
         <li onClick={() => { this.viewPage('competencies', item.id) }} key={`competency-item-${item.id}`}><small className={`component-score tier-${item.tier}-bg`}>{item.score}</small>{item.name}</li>
        )
       })}
      </ul>
     </div>

     <div className="components-list">
      <h6>AREAS OF IMPROVEMENT</h6>
      <ul className="thirds">
       {_.map(_.take(bottomCompetencies, 3), item => {
        return (
         <li onClick={() => { this.viewPage('competencies', item.id) }} key={`competency-item-${item.id}`}><small className={`component-score tier-${item.tier}-bg`}>{item.score}</small>{item.name}</li>
        )
       })}
      </ul>
     </div>

     {_.size(overEstimatedCompetencies) > 0 &&
      <div className="components-list">
       <h6>TOP BLIND SPOTS</h6>
       <ul className="thirds">
        {_.map(_.take(overEstimatedCompetencies, 3), item => {
         return (
          <li onClick={() => { this.viewPage('competencies', item.id) }} key={`overestimated-item-${item.id}`}><small className={`component-diff`}>{item.diff}</small>{item.name}</li>
         )
        })}
       </ul>
      </div>
     }

     {_.size(underEstimatedCompetencies) > 0 &&
      <div className="components-list">
       <h6>TOP HIDDEN STRENGTHS</h6>
       <ul className="thirds">
        {_.map(_.take(underEstimatedCompetencies, 3), item => {
         return (
          <li onClick={() => { this.viewPage('competencies', item.id) }} key={`underestimated-item-${item.id}`}><small className={`component-diff`}>+{item.diff}</small>{item.name}</li>
         )
        })}
       </ul>
      </div>
     }

     <div className="competencies-overview">
      <h2>Our 10 Selling Competencies</h2>
      <div className="competency-items">
       {_.map(competencies, (competency, index) => {
        return (
         <div key={`competency-${index}`} className="competency-item">
          <div className="name">{competency.name}</div>
          <div className="number">{index + 1}</div>
          {getIcon('competency-badge')}
         </div>
        )
       })}
      </div>
     </div>
    </div>
    <div className="review-page-section">

     {!printViewToggled &&
      <div className="sort-scores-by">
       <div className="label">Order selling competencies by...</div>
       <div className="sort-by-options">
        {_.map(this.hasPriorReview() ? ['Most Improved', 'Strongest', 'Weakest', 'Selling Cycle'] : ['Strongest', 'Weakest', 'Selling Cycle'], sortBy => {
         const selected = this.state.sortingCompetenciesBy === sortBy;

         return (
          <div key={`sort-by-${sortBy}`} onClick={() => { this.setState({ sortingCompetenciesBy: sortBy, viewingItems: {} }); }} className={`sort-by-option ${selected ? 'selected' : ''}`}>{sortBy}</div>
         )
        })}
       </div>
      </div>
     }
     {_.map(this.sortedCompetencyScores(), (item, index) => {

      const {id, score, tier, name, delta, } = item;
      const isViewingDetails = !!this.state.viewingItems[id];

      const sellingCompetency = getSellingCompetency(id);

      const questionsForCompetency = this.questionsForItem(item);

      const improveItems = this.getCompetencyItemsToImprove(questionsForCompetency);
      const leverageItems = this.getCompetencyItemsToLeverage(questionsForCompetency);

      const scoreClassification = this.getScoreClassification(score);

      return (
       <div onClick={() => { this.toggleViewingItem(id); }} id={`score-detail-for-${id}`} key={`score-for-${index}`} className={`score-with-detail ${!printViewToggled ? 'actionable' : ''} ${(isViewingDetails || printViewToggled) ? 'expanded' : ''}`}>
        <div className={`score medium ${delta ? 'has-delta' : ''}`}>
         <div className={`score-value tier-${tier}-bg`}>{score}</div>
         {delta &&
          <div className="score-delta">{delta > 0 ? '+' : ''}{delta}</div>
         }
        </div>
        <div className="description">
         <h4>{name}</h4>
         <p>{this. competencyDescriptionForProficiency(sellingCompetency, scoreClassification)}</p>
        </div>
        {(isViewingDetails || printViewToggled) &&
         <div onClick={(e) => { e.stopPropagation(); }} className="details">
          <h5>Individuals strong in {sellingCompetency.name} express the following characteristics...</h5>
          <ul className="characteristics-list">
           {_.map(sellingCompetency.characteristics, characteristic => {
            return <li>{characteristic}</li>
           })}
          </ul>
          <div className="questions">
           <div className="questions-legend">
            <h5>Item Breakdown:</h5>
            <div data-for="reviewer-type-tooltip" data-tip="Reviewer Score" className="reviewer-type">{getIcon('review-reviewer')}</div>
            <div data-for="reviewer-type-tooltip" data-tip="Seller Score" className="reviewer-type">{getIcon('review-self')}</div>
            {this.state.compareWithLatestTalentAssessment &&
              <div data-for="reviewer-type-tooltip" data-tip="Talent Assessment Response" className="reviewer-type">{getIcon('talents')}</div>
            }
           </div>
           {_.map(questionsForCompetency, (question, index) => {

            const { audience, id, sellerText, assessmentQuestionId } = question;

            const sellerScore = this.getResponseForQuestion(id, 'seller');
            const reviewerScore = this.getResponseForQuestion(id, 'reviewer');

            const questionIsBlindSpot = sellerScore - reviewerScore >= 2;
            const questionIsHiddenStrength = reviewerScore - sellerScore >= 2;

            const averageScore = this.getResponseForQuestion(id);
            const priorAverageScore = this.getResponseForQuestion(id, 'average', true)
            const questionIsImproved = averageScore - priorAverageScore >= 1.5;

            const tierQuestionIsImproved = (this.getResponseForQuestion(id, 'reviewer') - this.getResponseForQuestion(id, 'reviewer', true)) >= 1;

            const scoreFromTalentAssessment = this.hasPriorTalentAssessment() && ((this.state.compareWithLatestTalentAssessment || {}).responses || {})[assessmentQuestionId] || null;

            if(question.audience === 'both'){
             return (
              <div key={`question-${id}`} className="question">
               <div className="text">{sellerText}</div>
               <div className="question-scores">
                {scoreFromTalentAssessment &&
                  <div className={`question-score talent-assessment`}>{scoreFromTalentAssessment}<small>/7</small></div>
                }
                <div className={`question-score seller score-of-${sellerScore}`}>{sellerScore}<small>/7</small></div>
                <div className={`question-score reviewer score-of-${reviewerScore}`}>{reviewerScore}<small>/7</small></div>
               </div>
               {/*(questionIsHiddenStrength || questionIsBlindSpot || questionIsImproved) &&*/}
               <div className="question-props">
                {questionIsHiddenStrength && <div className="question-prop hidden-strength">{getIcon('hidden-strength')}<span>Hidden Strength</span></div>}
                {questionIsBlindSpot && <div className="question-prop blind-spot">{getIcon('blind-spot')}<span>Potential Blind Spot</span></div>}
                {questionIsImproved && <div className="question-prop improved">{getIcon('growth')}<span>Major Improvement</span></div>}
               </div>
              </div>
             )
            }
            else{
             return (
              <div key={`question-${id}`} className="question tier">
               <div className="text">Overall effectiveness</div>
                <div className="question-scores">
                 <div className={`question-score reviewer overall score-of-${reviewerScore}`}>{reviewerScore}<small>/7</small></div>
                </div>
                <div className="question-props">
                 {tierQuestionIsImproved && <div className="question-prop improved">{getIcon('growth')}<span>Major Improvement</span></div>}
                </div>
              </div>
             )
            }
           })}
          </div>
          <div className="leverage-and-improve">
           {leverageItems &&
            <div className="actionable-item">
             <h6>LEVERAGE YOUR LEADING STRENGTHS</h6>
             {_.map(leverageItems, item => {
              return <p key={item.id}>{item.leverageText}</p>
             })}
            </div>
           }
           {improveItems &&
            <div className="actionable-item">
             <h6>IMPROVE YOUR GREATEST WEAKNESSES</h6>
             {_.map(improveItems, item => {
              return <p key={item.id}>{item.improveText}</p>
             })}
            </div>
           }
          </div>
         </div>
        }
        <div onClick={() => { this.toggleViewingItem(id); }} className={`expand-toggle ${isViewingDetails ? 'toggled' : ''}`}>{getIcon('chevron-down')}</div>
       </div>
      )
     })}
    </div>
   </div>
  );
 }
 renderExpertisePage(){

  const scores = this.scoresFromReviewData();

  const {
   expertiseScore,
   expertiseTier,
   expertiseDelta,
   topExpertise,
   bottomExpertise,
   overEstimatedExpertise,
   underEstimatedExpertise,
  } = scores;

  const {
    isOwnReview
  } = this.props;

  const {
   printViewToggled
  } = this.state;

  const tierQuestionIsImproved = (this.getResponseForQuestion('criticalexpertisetier', 'reviewer') - this.getResponseForQuestion('criticalexpertisetier', 'reviewer', true)) >= 1;

  console.log('expertise scores: ', this.sortedExpertiseScores());

  return (
   <div className="review-page">
    <div className="review-page-hero print-full-page">
     <h2>Critical Expertise</h2>
     <ScoreProgress
      size="large"
      score={expertiseScore}
      priorScore={Number.isFinite(expertiseDelta) && (expertiseScore - expertiseDelta)}
      delta={expertiseDelta}
      className={`tier-${expertiseTier}`}
      color={getTierDetails(expertiseTier).color}
      />
      {isOwnReview &&
        <p>As the complexity of the sale has increased, more than ever, buyers value the expertise of the seller in their industry, solution domain, and business knowledge. Critical expertise is required to build credibility and confidence through competence. Within your role selling, the below areas of Critical Expertise have been identified as core to your success. These areas are equally weighted to comprise your overall Critical Expertise score and track your acquisition of knowledge as you build expertise in your field.</p>
      }
      {!isOwnReview &&
        <p>As the complexity of the sale has increased, more than ever, buyers value the expertise of the seller in their industry, solution domain, and business knowledge. Critical expertise is required to build credibility and confidence through competence. For the sellers on your team, the below areas of Critical Expertise have been identified as core to their success. These areas are equally weighted to comprise each seller’s overall Critical Expertise score to track knowledge acquisition and build credibility through expertise.</p>
      }
     <div className="components-list">
      <p>&nbsp;</p>
      <h6>TOP STRENGTHS</h6>
      <ul className="thirds">
       {_.map(_.take(topExpertise, 3), item => {
        return (
         <li onClick={() => { this.viewPage('expertise', item.id) }} key={`expertise-item-${item.id}`}><small className={`component-score tier-${item.tier}-bg`}>{item.score}</small>{item.name}</li>
        )
       })}
      </ul>
     </div>

     <div className="components-list">
      <h6>AREAS OF IMPROVEMENT</h6>
      <ul className="thirds">
       {_.map(_.take(bottomExpertise, 3), item => {
        return (
         <li onClick={() => { this.viewPage('expertise', item.id) }} key={`expertise-item-${item.id}`}><small className={`component-score tier-${item.tier}-bg`}>{item.score}</small>{item.name}</li>
        )
       })}
      </ul>
     </div>

     {_.size(underEstimatedExpertise) > 0 &&
      <div className="components-list">
       <h6>TOP BLIND SPOTS</h6>
       <ul className="thirds">
        {_.map(_.take(overEstimatedExpertise, 3), item => {
         return (
          <li onClick={() => { this.viewPage('expertise', item.id) }} key={`overestimated-item-${item.id}`}><small className={`component-diff`}>{item.diff}</small>{item.name}</li>
         )
        })}
       </ul>
      </div>
     }

     {_.size(underEstimatedExpertise) > 0 &&
      <div className="components-list">
       <h6>TOP HIDDEN STRENGTHS</h6>
       <ul className="thirds">
        {_.map(_.take(underEstimatedExpertise, 3), item => {
         return (
          <li onClick={() => { this.viewPage('expertise', item.id) }} key={`underestimated-item-${item.id}`}><small className={`component-diff`}>+{item.diff}</small>{item.name}</li>
         )
        })}
       </ul>
      </div>
     }

    </div>
    <div className="review-page-section">
     {!printViewToggled &&
      <div className="sort-scores-by">
       <div className="label">Order critical expertise by...</div>
       <div className="sort-by-options">
        {_.map(this.hasPriorReview() ? ['Most Improved', 'Strongest', 'Weakest'] : ['Strongest', 'Weakest'], sortBy => {
         const selected = this.state.sortingExpertiseBy === sortBy;

         return (
          <div key={`sort-by-${sortBy}`} onClick={() => { this.setState({ sortingExpertiseBy: sortBy, viewingItems: {} }); }} className={`sort-by-option ${selected ? 'selected' : ''}`}>{sortBy}</div>
         )
        })}
       </div>
      </div>
     }
     <div className="questions-legend force-break">
      <div data-for="critical-expertise-score-type-tooltip" data-tip="Reviewer Score" className="reviewer-type">{getIcon('review-reviewer')}</div>
      <div data-for="critical-expertise-score-type-tooltip" data-tip="Seller Score" className="reviewer-type">{getIcon('review-self')}</div>
      <ReactTooltip id={`critical-expertise-score-type-tooltip`} effect="solid" place="top" />
     </div>
     {_.map(this.sortedExpertiseScores(), ({ id, score, tier, name, delta, sellerScore, reviewerScore }, index) => {

      const questionIsBlindSpot = sellerScore - reviewerScore >= 2;
      const questionIsHiddenStrength = reviewerScore - sellerScore >= 2;

      const averageScore = this.getResponseForQuestion(id);
      const priorAverageScore = this.getResponseForQuestion(id, 'average', true)
      const questionIsImproved = averageScore - priorAverageScore >= 1.5;

      let expertiseItemDescription = false;
      const matchingExpertiseItem = _.find(((this.props.organization || {}).expertiseItems || []), { id });

      if(matchingExpertiseItem && matchingExpertiseItem.description){
       expertiseItemDescription = matchingExpertiseItem.description;
      }

      return (
       <div key={`score-for-${index}`} className="score-without-detail">
        <div className={`score medium`}>
         <div className={`score-value tier-${tier}-bg`}>{score}</div>
         {delta &&
          <div className="score-delta">{delta > 0 ? '+' : ''}{delta}</div>
         }
        </div>
        <div className="description">
         <h4>{name}</h4>
         <div className="questions">
          <div className="question">
           <div className="text">{getDefaultTalentRatingExplanations()[tier - 1]} at {name}</div>
           {expertiseItemDescription &&
            <div className="description">{expertiseItemDescription}</div>
           }
           <div className="question-scores">
            <div className={`question-score seller score-of-${sellerScore}`}>{sellerScore}<small>/7</small></div>
            <div className={`question-score reviewer score-of-${reviewerScore}`}>{reviewerScore}<small>/7</small></div>
           </div>
           {/*(questionIsHiddenStrength || questionIsBlindSpot || questionIsImproved) &&*/}
           <div className="question-props">
            {questionIsHiddenStrength && <div className="question-prop hidden-strength">{getIcon('hidden-strength')}<span>Hidden Strength</span></div>}
            {questionIsBlindSpot && <div className="question-prop blind-spot">{getIcon('blind-spot')}<span>Potential Blind Spot</span></div>}
            {questionIsImproved && <div className="question-prop improved">{getIcon('growth')}<span>Major Improvement</span></div>}
           </div>
          </div>
         </div>
        </div>

       </div>
      )
     })}
     <div className="score-without-detail">
      <div className="questions">
       <div className="question tier">
        <div className="text">Overall Effectiveness</div>
         <div className="question-scores">
          <div className={`question-score reviewer overall score-of-${this.getResponseForQuestion('criticalexpertisetier', 'reviewer')}`}>{this.getResponseForQuestion('criticalexpertisetier', 'reviewer')}<small>/7</small></div>
         </div>
         <div className="question-props">
          {tierQuestionIsImproved && <div className="question-prop improved">{getIcon('growth')}<span>Major Improvement</span></div>}
         </div>
       </div>
      </div>
     </div>
    </div>
   </div>
  );
 }
 renderCoachabilityPage(){
  const scores = this.scoresFromReviewData();

  const {
   coachabilityScore,
   coachabilityTier,
   coachabilityDelta,
  } = scores;

  const {
    isOwnReview
  } = this.props;

  const scoreForFirstCoachabilityQuestion = this.getResponseForQuestion('z3tafc');
  const scoreForSecondCoachabilityQuestion = this.getResponseForQuestion('fdsd44');
  const scoreForThirdCoachabilityQuestion = this.getResponseForQuestion('osqlb8');

  return (
   <div className="review-page">
    <div className="review-page-hero">
     <h2>Coachability</h2>
     <ScoreProgress
      score={coachabilityScore}
      priorScore={Number.isFinite(coachabilityDelta) && (coachabilityScore - coachabilityDelta)}
      delta={coachabilityDelta}
      className={`tier-${coachabilityTier}`}
      color={getTierDetails(coachabilityTier).color}
      />
    {isOwnReview &&
      <React.Fragment>
        <p>Sellers who continually improve with experience bring a Coachable mindset that enables optimal growth. An appetite for feedback, an open perspective, and an ability to adapt habits to improve effectiveness comprises the Seller’s Coachability score. Intentionally working on your Coachability scores will create a catalyst to effect growth across your Sales Competency and Critical Expertise scores for exponential improvement through experience over time.</p>
        <p>Intentionally working on your Coachability scores will create a catalyst to effect growth across your Sales Competency and Critical Expertise scores for exponential improvement through experience over time.</p>
      </React.Fragment>
    }
    {!isOwnReview &&
      <React.Fragment>
        <p>Sellers who continually improve with experience bring a Coachable mindset that enables optimal growth. An appetite for feedback, an open perspective, and an ability to adapt habits to improve effectiveness comprises the Seller’s Coachability score. Intentionally working on your Coachability scores will create a catalyst to effect growth across your Sales Competency and Critical Expertise scores for exponential improvement through experience over time.</p>
        <p>{this.personalizeWithSellerInfo(`Intentionally working on __SELLERNAMEP__ Coachability scores will create a catalyst to effect growth across __HISHER__ Sales Competency and Critical Expertise scores for exponential improvement through experience over time.`)}</p>
      </React.Fragment>
    }
    </div>
    <div className="review-page-section">
     <div className={`score-with-detail expanded`}>
      <div className="details">
       <div className="questions move-up-for-printing">
        <div className="questions-legend">
         <h5>Item Breakdown:</h5>
         <div data-for="reviewer-type-tooltip" data-tip="Reviewer Score" className="reviewer-type">{getIcon('review-reviewer')}</div>
         <div data-for="reviewer-type-tooltip" data-tip="Seller Score" className="reviewer-type">{getIcon('review-self')}</div>

        </div>
        {_.map(this.coachabilityQuestions(), (question, index) => {

         const { audience, id, sellerText, ratingType } = question;

         const sellerScore = this.getResponseForQuestion(id, 'seller');
         const reviewerScore = this.getResponseForQuestion(id, 'reviewer');

         const questionIsBlindSpot = sellerScore - reviewerScore >= 2;
         const questionIsHiddenStrength = reviewerScore - sellerScore >= 2;

         const averageScore = this.getResponseForQuestion(id);
         const priorAverageScore = this.getResponseForQuestion(id, 'average', true)
         const questionIsImproved = averageScore - priorAverageScore >= 1.5;

         const tierQuestionIsImproved = (this.getResponseForQuestion(id, 'reviewer') - this.getResponseForQuestion(id, 'reviewer', true)) >= 1;

         if(ratingType === 'likert'){
          return (
           <div key={`question-${id}`} className="question">
            <div className="text">{sellerText}</div>
            <div className="question-scores">
             <div className={`question-score seller score-of-${sellerScore}`}>{sellerScore}<small>/7</small></div>
             <div className={`question-score reviewer score-of-${reviewerScore}`}>{reviewerScore}<small>/7</small></div>
            </div>
            {/*(questionIsHiddenStrength || questionIsBlindSpot || questionIsImproved) &&*/}
            <div className="question-props">
             {questionIsHiddenStrength && <div className="question-prop hidden-strength">{getIcon('hidden-strength')}<span>Hidden Strength</span></div>}
             {questionIsBlindSpot && <div className="question-prop blind-spot">{getIcon('blind-spot')}<span>Potential Blind Spot</span></div>}
             {questionIsImproved && <div className="question-prop improved">{getIcon('growth')}<span>Major Improvement</span></div>}
            </div>
           </div>
          )
         }
         else{
          return (
           <div key={`question-${id}`} className="question tier">
            <div className="text">Overall effectiveness</div>
             <div className="question-scores">
              <div className={`question-score reviewer overall score-of-${reviewerScore}`}>{reviewerScore}<small>/7</small></div>
             </div>
             <div className="question-props">
              {tierQuestionIsImproved && <div className="question-prop improved">{getIcon('growth')}<span>Major Improvement</span></div>}
             </div>
           </div>
          )
         }
        })}
       </div>
       <div className="leverage-and-improve">
        <div className="actionable-item">
         <h6>COACHABILITY IMPACT</h6>
           {isOwnReview &&
             <p>
               {scoreForFirstCoachabilityQuestion >= 5 &&
                 <span>Your scores support that you, like top sellers from our research, actively seek feedback for ongoing improvement. Your hunger to learn makes you get better faster. </span>
               }
               {scoreForFirstCoachabilityQuestion < 5 &&
                 <span>Your scores indicate that you don’t actively seek feedback for ongoing improvement, which is something that top sellers do. This passive approach will slow your progress. </span>
               }
               {scoreForSecondCoachabilityQuestion >= 5 &&
                 <span>You listen openly to feedback and welcome ideas for improvement. This open mindset will enable you to internalize input for growth. </span>
               }
               {scoreForSecondCoachabilityQuestion < 5 &&
                 <span>You don’t always listen openly to feedback and welcome ideas for improvement. This restricted mindset will inhibit your ability to internalize input for growth. </span>
               }
               {scoreForThirdCoachabilityQuestion >= 5 &&
                 <span>You apply focus and persistence in applying feedback for ongoing improvement, which increases your potential for success.</span>
               }
               {scoreForThirdCoachabilityQuestion < 5 &&
                 <span>You lack focus and persistence in implementing feedback, which inhibits your potential for success. What can you do to ensure you follow through to improve?</span>
               }
             </p>
           }
           {!isOwnReview &&
             <p>
               {scoreForFirstCoachabilityQuestion >= 5 &&
                 <span dangerouslySetInnerHTML={{ __html: this.personalizeWithSellerInfo(`__SELLERNAMEP__ scores support that __HESHE__, like top sellers from our research, actively seeks feedback for ongoing improvement. __HISHERC__ hunger to learn makes __HISHER__ get better faster. `)}}></span>
               }
               {scoreForFirstCoachabilityQuestion < 5 &&
                 <span dangerouslySetInnerHTML={{ __html: this.personalizeWithSellerInfo(`__SELLERNAMEP__ scores indicate that __HESHE__ doesn’t actively seek feedback for ongoing improvement, which is something that top sellers do. This passive approach will slow __HISHER__ progress if not addressed. `)}}></span>
               }
               {scoreForSecondCoachabilityQuestion >= 5 &&
                 <span dangerouslySetInnerHTML={{ __html: this.personalizeWithSellerInfo(`__SELLERNAME__ listens openly to feedback and welcomes ideas for improvement. This open mindset will enable __HISHER__ to internalize input for growth. `)}}></span>
               }
               {scoreForSecondCoachabilityQuestion < 5 &&
                 <span dangerouslySetInnerHTML={{ __html: this.personalizeWithSellerInfo(`__SELLERNAME__ doesn’t always listen openly to feedback and welcome ideas for improvement. This restricted mindset will inhibit __HISHER__ ability to internalize input for growth. `)}}></span>
               }
               {scoreForThirdCoachabilityQuestion >= 5 &&
                 <span dangerouslySetInnerHTML={{ __html: this.personalizeWithSellerInfo(`__SELLERNAME__ applies focus and persistence in applying feedback for ongoing improvement, which will increase __HISHER__ potential for success.`)}}></span>
               }
               {scoreForThirdCoachabilityQuestion < 5 &&
                 <span dangerouslySetInnerHTML={{ __html: this.personalizeWithSellerInfo(`__SELLERNAME__ lacks focus and persistence in implementing feedback, which inhibits __HISHER__ potential for success. What can you do to ensure __HESHE__ follows through to improve?`)}}></span>
               }
             </p>
           }
         {/*
         {isOwnReview &&
           <React.Fragment>
             {scoreForFirstCoachabilityQuestion >= 5 &&
               <p>Your scores support that you, like top sellers from our research, <b>actively seek feedback</b> for ongoing improvement. Your hunger to learn makes you get better faster. </p>
             }
             {scoreForFirstCoachabilityQuestion < 5 &&
               <p>Your scores indicate that you <b>don’t actively seek feedback</b> for ongoing improvement, which is something that top sellers do. This passive approach will slow your progress. </p>
             }
             {scoreForSecondCoachabilityQuestion >= 5 &&
               <p>You <b>listen openly to feedback</b> and welcome ideas for improvement. This open mindset will enable you to internalize input for growth. </p>
             }
             {scoreForSecondCoachabilityQuestion < 5 &&
               <p>You <b>don’t always listen openly to feedback and welcome ideas for improvement</b>. This restricted mindset will inhibit your ability to internalize input for growth. </p>
             }
             {scoreForThirdCoachabilityQuestion >= 5 &&
               <p>You <b>apply focus and persistence in applying feedback for ongoing improvement</b>, which increases your potential for success.</p>
             }
             {scoreForThirdCoachabilityQuestion < 5 &&
               <p>You <b>lack focus and persistence in implementing feedback</b>, which inhibits your potential for success. What can you do to ensure you follow through to improve?</p>
             }
           </React.Fragment>
         }
         {!isOwnReview &&
           <React.Fragment>
             {scoreForFirstCoachabilityQuestion >= 5 &&
               <p dangerouslySetInnerHTML={{ __html: this.personalizeWithSellerInfo(`__SELLERNAMEP__ scores support that __HESHE__, like top sellers from our research, <b>actively seeks feedback for ongoing improvement</b>. __HISHERC__ hunger to learn makes __HISHER__ get better faster. `)}}></p>
             }
             {scoreForFirstCoachabilityQuestion < 5 &&
               <p dangerouslySetInnerHTML={{ __html: this.personalizeWithSellerInfo(`__SELLERNAMEP__ scores indicate that __HESHE__ <b>doesn’t actively seek feedback for ongoing improvement</b>, which is something that top sellers do. This passive approach will slow __HISHER__ progress if not addressed. `)}}></p>
             }
             {scoreForSecondCoachabilityQuestion >= 5 &&
               <p dangerouslySetInnerHTML={{ __html: this.personalizeWithSellerInfo(`__SELLERNAME__ <b>listens openly to feedback and welcomes ideas for improvement</b>. This open mindset will enable __HISHER__ to internalize input for growth. `)}}></p>
             }
             {scoreForSecondCoachabilityQuestion < 5 &&
               <p dangerouslySetInnerHTML={{ __html: this.personalizeWithSellerInfo(`__SELLERNAME__ <b>doesn’t always listen openly to feedback and welcome ideas for improvement</b>. This restricted mindset will inhibit __HISHER__ ability to internalize input for growth. `)}}></p>
             }
             {scoreForThirdCoachabilityQuestion >= 5 &&
               <p dangerouslySetInnerHTML={{ __html: this.personalizeWithSellerInfo(`__SELLERNAME__ <b>applies focus and persistence in applying feedback</b> for ongoing improvement, which will increase __HISHER__ potential for success.`)}}></p>
             }
             {scoreForThirdCoachabilityQuestion < 5 &&
               <p dangerouslySetInnerHTML={{ __html: this.personalizeWithSellerInfo(`__SELLERNAME__ <b>lacks focus and persistence in implementing feedback</b>, which inhibits __HISHER__ potential for success. What can you do to ensure __HESHE__ follows through to improve?`)}}></p>
             }
           </React.Fragment>
         }*/}
        </div>
       </div>
      </div>
     </div>
    </div>
   </div>
  );
 }

 renderNotesPage(){
  return (
   <div className="review-page">
    <div className="review-page-hero print-full-page">
     <h2>Reviewer Notes</h2>
     <p className="notes">{this.getResponseForQuestion('notes', 'reviewer')}</p>
    </div>
   </div>
  )
 }

 renderCurrentPage(){
  const {
   viewingPage,
   printViewToggled,
  } = this.state;

  return (
   <React.Fragment>
    {(printViewToggled || viewingPage === 'intro') && this.renderIntroPage()}
    {(printViewToggled || viewingPage === 'summary') && this.renderSummaryPage()}
    {(printViewToggled || viewingPage === 'takeaways') && this.renderTakeawaysPage()}
    {(printViewToggled || viewingPage === 'competencies') && this.renderCompetenciesPage()}
    {(printViewToggled || viewingPage === 'expertise') && this.renderExpertisePage()}
    {(printViewToggled || viewingPage === 'coachability') && this.renderCoachabilityPage()}
    {(printViewToggled || viewingPage === 'notes') && this.renderNotesPage()}
   </React.Fragment>
  )
 }

 viewPage(page, itemId){
  this.setState({
   viewingPage: page,
   ...(itemId && { viewingItems: {
    ...this.state.viewingItems,
    [itemId]: true,
   }})
  });

  if(itemId){
   scrollTo(`score-detail-for-${itemId}`);
  }
 }

 componentWillMount(){
  const { match: { params } } = this.props;

  this.props.fetchSalesCompetencyReview(params.reviewId);

  //fetch review items if we don't already have
  if(!this.props.salesCompetencyReviewItems){
   this.props.fetchSalesCompetencyReviewItems();
  }

  //bind listener to print request, and enable print view before printing
  //https://www.tjvantoll.com/2012/06/15/detecting-print-requests-with-javascript/
  (function(_this) {

   var beforePrint = function() {
     _this.setState({
      printViewToggled: true
     });
   };
   // var afterPrint = function() {
   //   console.log('Functionality to run after printing');
   // };

   if (window.matchMedia) {
     var mediaQueryList = window.matchMedia('print');
     mediaQueryList.addListener(function(mql) {
       if (mql.matches) {
         beforePrint();
       } else {
         //afterPrint();
       }
     });
   }

   window.onbeforeprint = beforePrint;
   // window.onafterprint = afterPrint;
  }(this));

 }

 renderPageSelect(){
  const {
   viewingPage,
   printViewToggled,
  } = this.state;

  if(printViewToggled){
   return null;
  }

  return (
   <div className="review-page-selector">
    <div onClick={() => { this.viewPage('intro'); }} className={`page-select ${viewingPage === 'intro' ? 'selected' : ''}`}>Intro</div>
    <div onClick={() => { this.viewPage('summary'); }} className={`page-select ${viewingPage === 'summary' ? 'selected' : ''}`}>Summary</div>
    <div onClick={() => { this.viewPage('takeaways'); }} className={`page-select ${viewingPage === 'takeaways' ? 'selected' : ''}`}>Key Takeaways</div>
    <div onClick={() => { this.viewPage('competencies'); }} className={`page-select ${viewingPage === 'competencies' ? 'selected' : ''}`}>Competencies</div>
    <div onClick={() => { this.viewPage('expertise'); }} className={`page-select ${viewingPage === 'expertise' ? 'selected' : ''}`}>Expertise</div>
    <div onClick={() => { this.viewPage('coachability'); }} className={`page-select ${viewingPage === 'coachability' ? 'selected' : ''}`}>Coachability</div>
    <div onClick={() => { this.viewPage('notes'); }} className={`page-select ${viewingPage === 'notes' ? 'selected' : ''}`}>Notes</div>
   </div>
  )
 }

 renderGoHomeButton(){
  return (
   <Link to={`${navPrefix()}/salesCompetencies`} className="go-home no-print">Sales Competencies Home</Link>
  )
 }

 renderPrintViewToggle(){

  const { printViewToggled } = this.state;

  return (
   <div className="print-view-toggle">
    <div data-for="print-view-toggle-tip" data-tip={!printViewToggled ? 'Currently in INTERACTIVE view' : 'Enter INTERACTIVE view'} onClick={this.togglePrintView.bind(this)} className={`toggle print-view-off ${!printViewToggled ? 'toggled' : ''}`}>{getIcon('desktop')}</div>
    <div data-for="print-view-toggle-tip" data-tip={printViewToggled ? 'Current in PRINT view' : 'Enter PRINT view'} onClick={this.togglePrintView.bind(this)} className={`toggle print-view-off ${printViewToggled ? 'toggled' : ''}`}>{getIcon('print')}</div>
    <ReactTooltip id="print-view-toggle-tip" effect="solid" place="top" />
   </div>
  )
 }

 sellerName(possessive: false, useFullName: false){

  let name = '';

  if(useFullName){
   name = this.props.viewingUser ? (this.props.viewingUser.firstName + ' ' + this.props.viewingUser.lastName) : ((this.props.user || {}).firstName || '') + ' ' + ((this.props.user || {}).lastName || '');
  }
  else{
   name = this.props.viewingUser ? this.props.viewingUser.firstName : (this.props.user || {}).firstName || '';
  }

  return `${name}${possessive ? '\'s' : ''}`;
 }

 renderPrintViewInstructions(){

  const afterModal = () => {
   this.setState({
    showingPrintViewInstructions: false,
    hasSeenPrintViewInstructions: true,
   });
  }

  const messageHtml = `
   <div>
    <p><small>Before printing:</small></p>
    <p><b>Chrome (Best)</b><br/><small>1) Click "More Settings" 2) Set "Margins" to "None" 3) Check to enable "Background graphics"</small></p>
    <p><b>Safari (Ok)</b><br/><small>1) Click "Show Details" 2) Check to enable "Print backgrounds" 3) Uncheck to disable "Print headers and footers"</small></p>
    <p><b>Firefox (Not Recommended)</b><br/><small>1) Click "Show Details" 2) Check to enable "Print Background Colors" in "Appearance" 3) Set all Page Headers & Footers to "--blank--"</small></p>
   </div>
  `;

  return(
   <MessageModal
    messageHtml={messageHtml}
    visible={true}
    hide={afterModal}
    />
  )
 }

 hasPriorTalentAssessmentResponses(){

 }

 render(){

  const {
   loadingPredictiveSkillsReview,
   loadingPredictiveSkillsReviewItems,
   salesCompetencyReviewItems,
   currentReview,
   priorReview,
  } = this.props;

  const {
   printViewToggled,
   showingPrintViewInstructions,
  } = this.state;

  if(loadingPredictiveSkillsReview || loadingPredictiveSkillsReviewItems){ return null; }

  return (
   <Page pageClass="sales-competency-review" loading={loadingPredictiveSkillsReview || loadingPredictiveSkillsReviewItems}>
    <div className={`viewing-review ${printViewToggled ? 'print-view' : ''}`}>
     {this.renderPrintViewToggle()}
     {this.renderGoHomeButton()}
     <h1>{getFormattedQuarterFromDate(currentReview.startedOn)} Sales Competency Review{!this.props.isOwnReview && ` for ${this.sellerName(false, true)}`}</h1>
     {this.hasPriorReview() &&
      <h4 className="subheader">Comparing with previous review on {getFormattedQuarterFromDate(priorReview.startedOn)}</h4>
     }
     {this.hasPriorTalentAssessment() &&
       <h4 className="subheader">Includes initial Talent Assessment Responses from {moment(this.state.compareWithLatestTalentAssessment.scoredOn.toDate()).format('M/D/YY')}</h4>
     }
     {this.renderPageSelect()}
     {this.renderCurrentPage()}
    </div>
    {showingPrintViewInstructions && this.renderPrintViewInstructions()}
    <ReactTooltip id="reviewer-type-tooltip" effect="solid" place="top" />
   </Page>
  )
 }
}

const mapStateToProps = state => {
 return {
  user: state.user.data,
  viewingUser: state.viewingUser.data,
  organization: state.organization.data,
  salesCompetencyReviewItems: state.salesCompetencyReviewItems.items,
  loadingPredictiveSkillsReviewItems: state.salesCompetencyReviewItems.loading,

  currentReview: state.viewingSalesCompetencyReview.currentReview,
  priorReview: state.viewingSalesCompetencyReview.priorReview,
  loadingPredictiveSkillsReview: state.viewingSalesCompetencyReview.loading,

  isOwnReview: !state.viewingUser.data,
  scoredCriticalExpertiseItems: ScoredCriticalExpertiseItemsSelector(state),
 }
}

export default connect(mapStateToProps, { fetchSalesCompetencyReview, fetchSalesCompetencyReviewItems })(ViewTalentReview);



// WEBPACK FOOTER //
// ./src/components/salesCompetencies/viewSalesCompetencyReview.js